import * as types from "./mutation-types";
import axios from "axios"

export const clear = ({commit}) => {
    commit(types.CLEAR);
}

export const setLocale = ({commit}, locale) => {
    commit(types.SET_LOCALE, locale);
}

export const setApiConfig = ({commit}, apiConfig) => {
    commit(types.SET_API_CONFIG, apiConfig);
}

export const setToken = ({commit}, token) => {
    commit(types.SET_TOKEN, token);
}

export const setNetworkState = ({commit}, networkState) => {
    commit(types.SET_NETWORK_STATE, networkState);
}

export const setAuthInfo = ({commit}, authInfo) => {
    commit(types.SET_AUTH_INFO, authInfo);
}

export const setFoodClassify = ({commit},foodClassify) =>{
    commit(types.SET_FOOD_CLASSIFY, foodClassify);    
}
export const setFoodInfo = ({commit},foodInfo)=>{
    commit(types.SET_FOOD_INFO,foodInfo);
}

export const setSeq = ({commit},seq)=>{
    commit(types.SET_SEQ,seq);
}
